
import { Component, Mixins, Model, Prop, Watch } from 'vue-property-decorator';
import BaseInput from './mixins/BaseInput';
import CustomService from './CustomService.vue';
import {
  CustomService as CustomServiceModel,
  CustomServiceCreatorRoleEnum,
  GeneralInvoicingTargetEnum,
} from '@gid/models';

@Component({ components: { CustomService } })
export default class CustomServices extends Mixins(BaseInput) {
  @Prop() readonly jobId!: string;
  @Prop() editable!: boolean;
  @Prop() readonly!: boolean;
  @Prop() showCreate!: boolean;
  @Prop() showServiceHints!: boolean;
  @Prop() context!: string;
  @Prop() invoicing_target!: GeneralInvoicingTargetEnum;
  @Prop() editInvoicingTarget!: boolean;
  @Prop({ default: false }) disableCustomServices!: boolean;
  @Prop({ default: false }) allowSelection!: boolean;
  @Prop({ type: Array, default: () => [] }) selections?: any;

  @Model('input', { type: Array })
  modelCustomServices!: Array<{
    price_purchasing: number;
    price_lists: number;
    price_selling: number;
  }>;

  get items() {
    return this.modelCustomServices;
  }

  get hasItems() {
    return this.items?.length;
  }

  get errors() {
    return this.$store.getters.customServicesErrors;
  }

  get user() {
    return this.$store.getters.user;
  }

  addService() {
    if (!this.modelCustomServices) return;

    const contact = this.user?.contact;
    let newService = {
      creator_role: CustomServiceCreatorRoleEnum.PARTNER,
      creator_name: `${contact.first_name} ${contact.last_name}`,
      measure: 'Count',
      quantity: 1,
      invoicing_target: this.invoicing_target,
      price_purchasing: 0,
      price_lists: 0,
      price_selling: 0,
      service_type: null,
      sort_index: null,
      headline: null,
    };
    if (this.context === 'admin') {
      newService = {
        ...newService,
        creator_role: CustomServiceCreatorRoleEnum.ADMIN,
      };
    }
    this.modelCustomServices?.push(newService);
  }

  resetServices() {
    this.$store.dispatch('CUSTOM_SERVICE_RESET_ERRORS');
    this.modelCustomServices = [];
  }

  deleteService(serviceIndex) {
    this.$store.dispatch('CUSTOM_SERVICE_PUSH_ERROR', { index: serviceIndex });
    this.modelCustomServices.splice(serviceIndex, 1);
  }
}
